import { ServiceMaker, methods, services } from "../services";

export const createConcern = payload =>
  ServiceMaker(
    `/smsemail/concern/create`,
    methods.POST,
    services.master,
    payload
  );

export const deleteConcern = Id =>
  ServiceMaker(
    `/smsemail/delete-concern/${Id}`,
    methods.DELETE,
    services.master
  );

export const concernListFilter = payload =>
  ServiceMaker(
    `/smsemail/concern-list?name=${payload.name}&type=${payload.type}`,
    methods.GET,
    services.master
  );